import { Trans } from 'react-i18next';

import type { PrepaySelectData, PrepaySelectHandlers } from '@ctct/application-layer';
import { CardSelect, Heading } from '@ctct/payflow-ui';
import type { PrepaySelectHooks } from '@ctct/state-client-layer';

interface Props {
  data: PrepaySelectData;
  handlers: PrepaySelectHandlers;
  hooks: PrepaySelectHooks;
  isSingleBillChildAccount?: boolean;
}

export const PrepaySelectWidgetCustomerContent = ({ data, handlers, hooks, isSingleBillChildAccount }: Props) => {
  const disabled = Boolean(hooks.useDisabled() || isSingleBillChildAccount);
  const prepay = hooks.usePrepay();
  const planBaseMonthlyPrice = hooks.usePlanBaseMonthlyPrice();

  const periodOptions = data.getCustomerPeriodOptions(planBaseMonthlyPrice).map((option) => ({
    ...option,
    disabled: disabled || option.disabled,
    value: (
      <>
        <Trans i18nKey={option.labelI18nKey} values={{ discountPercent: option.discountPercent }} />
        {option.isCurrent && <Trans i18nKey="application-layer.payment-plans.current-plan" />}
      </>
    ),
    topDescription: (
      <Trans
        i18nKey={option.descriptionI18nKey}
        values={{ savingsAmount: option.savings }}
        components={{ span: <span className="payment-plans__savings" /> }}
      />
    ),
  }));

  const hasEnabledOption = periodOptions.some((option) => !option.disabled);
  const selectedValue = hasEnabledOption ? prepay : '';

  return (
    <>
      <Heading level="h6" className="payment-plan-heading">
        <Trans i18nKey="application-layer.payment-plans.heading" />
      </Heading>
      <CardSelect
        options={periodOptions}
        value={selectedValue}
        onOptionSelect={handlers.onPrepayChange}
        disabled={disabled}
        type="payment-plan"
        allowDeselect={false}
      />
    </>
  );
};
